<div class="maintenance-container">
  <img src="assets/maintenance.gif" alt="Maintenance Image" />
  <h1>We're currently under maintenance</h1>
  <p>Please check back later. Thank you for your patience!</p>

  <h2>Estimated time remaining:</h2>
  <div class="countdown">{{ remainingTime }}</div>
</div>
